<!--
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description:
-->
<template>
  <el-dialog width="500" :visible="isShow" :close-on-click-modal="false" :modal-append-to-body="false" :append-to-body="true" :show-close="false">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 部品待选清单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-button type="success" size="mini" icon="el-icon-finished" @click="handlerEnter">确定选择</el-button>
    <div class="dialog-search-container">
      <el-input size="mini" placeholder="请输入部品名称" v-model="query.materialName">
        <template slot="prepend">搜索：</template>
        <el-button slot="append" icon="el-icon-search" @click="handlerSearch"></el-button>
      </el-input>
    </div>
    <div class="dialog-main-container">
      <el-table :data="dataList" size="mini" height="410px" style="width: 100%;" stripe border header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
        <el-table-column label="部品名称" prop="name" align="center"></el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination :page-size="query.pageSize" :page-count="query.pageSize" layout="prev, pager, next" :total="query.totalCount"></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      query: {
        materialName: '',
        code: '',
        pn: 1, // 页码
        pageSize: 100, // 每页条数
        totalCount: 0 // 数据总条数
      },
      // 当前子组件对话框的显隐
      isShow: false,
      // 部品列表
      dataList: [],
      selectedDs: []
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
    loadData: function () {
      const _this = this
      _this.query.code = '001'
      _this.post(_this.$apis.getInstoreProductParts, _this.query, function (res) {
        const _json = res.data
        _this.dataList = _json.dataList
      })
    },
    open: function (employees) {
      this.loadData()
      this.isShow = true
    },
    close: function () {
      this.isShow = false
    },
    // 多选事件
    handleSelectionChange: function (selection) {
      this.selectedDs = selection
    },
    // 搜索事件
    handlerSearch: function () {
      this.loadData()
    },
    // 确定选择
    handlerEnter: function () {
      const _this = this
      let _selectedCount = this.selectedDs.length
      for (let i = 0; i < _selectedCount; ++i) {
        // 此处必须进行深拷贝，否则添加的明细，将都指向了一个对象
        let _newDetail = JSON.parse(JSON.stringify(_this.parent.formDetailEmptyData))
        _newDetail.base_material_id = _this.selectedDs[i].id
        _newDetail.base_material_name = _this.selectedDs[i].name
        _this.parent.formData.details.push(_newDetail)
      }
      _this.close()
    }
  },
  components: {
  }
}
</script>
